import PropTypes from 'prop-types';
import React from 'react';
import { isIE } from '../../../Share/utils';
import { Modal, TFVButton } from '../../../Share/components';

function ResetPassword({
  isVisible = false,
  onClose = () => {},
  userName = '',
  onClick = () => {},
}) {
  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText="Återställ lösenordet"
      className="tv-cancel-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-3">
        Är du säker på att du vill återställa lösenordet för {userName}?
      </p>
      <div className="justify-content-between tv-display-flex gap-4 tv-cancel-license__modal__footer mt-5">
        <TFVButton
          type="line-primary"
          buttonType="button"
          className="w-50"
          text="Avbryt"
          onClick={onClose}
        />
        <TFVButton
          type="secondary"
          buttonType="button"
          className="w-50"
          text="Återställ"
          onClick={onClick}
        />
      </div>
    </Modal>
  );
}

ResetPassword.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  userName: PropTypes.string,
  onClick: PropTypes.func,
};

export default ResetPassword;
